<template>
  <div
    v-if="member"
    class="row d-flex justify-content-between"
  >
    <div class="col-2 item">
      #{{ member.id }}
    </div>
    <div class="col-8 item">
      <div class="w-100">
        <div class="d-flex align-items-center">
          <div
            v-lazy-container="{ selector: 'img', loading: $store.getters['user/emptyAvatar'], error: $store.getters['user/emptyAvatar'] }"
            class="avatar mr-2"
          >
            <img :data-src="$store.getters['user/getAvatar'](member.influencerData)">
          </div>
          {{ member.influencerData.userName }}
          ({{ member.influencerData.fullName }})
          <img
            v-if="campaign.status != 'canceled' && !member.banned && !banView"
            class="ban-user ml-auto"
            :src="`${$publicPath}img/campaigns-cpc/x.svg`"
            :title="$t('view-CampaignsCpcDetails.Members.button.ban')"
            @click="banView = !banView"
          >
        </div>
        <div
          v-if="member.banned"
          class="mt-2"
        >
          <span class="banned">{{ $t('view-CampaignsCpcDetails.Members.banned') }}</span>
        </div>
        <div v-if="banView">
          <div class="mt-3">
            <validation-observer
              ref="observer"
            >
              <validation-provider
                v-slot="validationContext"
                :name="$t('view-CampaignsCpcDetails.Members.input-name.message')"
                :rules="{ required: true }"
              >
                <b-form-group
                  :label="$t('view-CampaignsCpcDetails.Members.input.message')"
                  label-for="message"
                  class="require-mark"
                >
                  <b-form-textarea
                    id="message"
                    v-model="message"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-cons-feedback"
                    type="text"
                  />
                  <b-form-invalid-feedback id="message-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </validation-observer>
          </div>
          <div class="d-flex justify-content-between">
            <std-button
              type="C"
              :title="$t('common.button.cancel')"
              :direction="'left'"
              @click="banView = false"
            />
            <std-button
              type="D"
              :title="$t('view-CampaignsCpcDetails.Members.button.ban')"
              @click="submitHandler"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-7 item text-wrap text-break">
      {{ member.ref_link }}
    </div>
    <div class="col-3 item">
      <div class="w-100 text-center">
        <clicks-chart
          v-if="report"
          :report="report"
          :show-labels="false"
        />
        <span v-else>---</span>
      </div>
    </div>
  </div>
</template>

<script>
import ClicksChart from './ClicksChart.vue'

export default {
  components: {
    'clicks-chart': ClicksChart
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    member: {
      type: Object,
      default: () => { return null }
    },
    report: {
      type: Object,
      default: () => { return null }
    }
  },
  data () {
    return {
      banView: false,
      buttonLoader: false,
      message: null
    }
  },
  methods: {
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    submitHandler: async function () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid || this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      const formData = {
        campaignCpcId: this.campaign.id,
        memberId: this.member.id,
        message: this.message
      }
      this.$store.dispatch('campaignsCpcAdvertiser/banMember', formData)
        .then(() => {
          this.$flash.success(this.$t('view-CampaignsCpcDetails.Members.edit-successfull'))

          this.message = null
          this.$refs.observer.reset()
          this.banView = false
          this.buttonLoader = false
        })
        .catch((e) => {
          if (e.response.status === 422) {
            this.$flash.error(this.$t(e.response.body.errors[0]))
          } else {
            this.$flash.error(this.$t('view-CampaignsCpcDetails.Members.edit-error'))
          }
          this.buttonLoader = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .banned {
    background-color: $danger;
    color: white;
    padding: 0.2rem 0.5rem;
    border-radius: 5px;
  }
  .ban-user {
    cursor: pointer;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .nh-btn {
    min-width: 150px;
    padding: 0.5rem 1.25rem;
  }
</style>
